import BaseModulePlugins from '@/store/baseModule/plugins';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseModule from '@/store/baseModule';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import registerPlanned from './planned';

export default (store) => {
  store.registerModule(
    ['properties', 'interventions'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({}),
        treatListResponse: treatsItems({
          datetimeFieldNames: ['event_datetime'],
        }),
      }),
      attributesObj: {
        reference: { serverSide: true, values: [] },
        scheduled_type: { serverSide: true, values: ['E'] },
      },
      makeHttpParamsUrl: (id) =>
        `${process.env.P2C_BASE_URI}/properties/${id}/interventions_in_progress`,
      makeQueryParams: makeListRequest({
        useEntities: false,
      }),
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: 'properties/interventions',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.onActiveRequestChange((payload) => {
      store.dispatch('properties/interventions/setAttributesObj', {
        ...store.getters['properties/interventions/attributesObj'],
        reference: {
          ...store.getters['properties/interventions/attributesObj'].reference,
          serverSide: true,
          values: [],
        },
      });
      store.dispatch(
        'properties/interventions/setUrlParamId',
        payload.property_id
      );
    });
  });
  registerPlanned(store);
};
